import * as types from "../../ActionType";

const initState = {
    page_list_transaction: {},
    loadingPageListTransaction: true,
    transactions: [],
    loadingTransactions: true
}

const TransactionsReducer = (state = initState, action) => {
    switch (action.type) {
        case types.PAGE_LIST_TRANSACTIONS:
            return { ...state, page_list_transaction: action.payload, loadingPageListTransaction: false }
        case types.ADD_TRANSACTION:
            return { ...state, loadingTransactions: true }
        case types.GET_TRANSACTIONS:
            return { ...state, transactions: action.payload, loadingTransactions: false }
        case types.CANCEL_TRANSACTION:
            return { ...state }
        case types.EDIT_TRANSACTION:
            return { ...state, loadingTransactions: true }
        default:
            return state;
    }
};

export default TransactionsReducer;
